var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-steps--container" },
    [
      _c("customer-autocomplete", {
        ref: "customerAutocomplete",
        attrs: {
          id: "customer-filter",
          "team-region-id": _vm.teamRegionId,
          value: _vm.selectedCustomer,
          label: "Customer",
        },
        on: { input: _vm.handleCustomerChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }